export interface LeadContact {
  id: number;
  name: string;
  position: string;
  work_phone: string;
  work_email: string;
  created_at: string;
}

export const mockLeadContacts: LeadContact[] = [
  {
    id: 1,
    name: "Иван Петров",
    position: "Генеральный директор",
    work_phone: "+7 (495) 123-45-67",
    work_email: "ivan.petrov@techstart.ru",
    created_at: "2024-01-15T10:30:00Z",
  },
  {
    id: 2,
    name: "Мария Козлова",
    position: "HR-менеджер",
    work_phone: "+7 (495) 234-56-78",
    work_email: "maria.kozlov@innovations.ru",
    created_at: "2024-01-14T14:20:00Z",
  },
  {
    id: 3,
    name: "Алексей Смирнов",
    position: "Финансовый директор",
    work_phone: "+7 (495) 345-67-89",
    work_email: "alexey.smirnov@progress.ru",
    created_at: "2024-01-13T09:15:00Z",
  },
  {
    id: 4,
    name: "Елена Волкова",
    position: "Коммерческий директор",
    work_phone: "+7 (495) 456-78-90",
    work_email: "elena.volkova@startup.ru",
    created_at: "2024-01-12T16:45:00Z",
  },
  {
    id: 5,
    name: "Дмитрий Орлов",
    position: "Технический директор",
    work_phone: "+7 (495) 567-89-01",
    work_email: "dmitry.orlov@future.ru",
    created_at: "2024-01-11T11:30:00Z",
  },
  {
    id: 6,
    name: "Анна Морозова",
    position: "Маркетинг-менеджер",
    work_phone: "+7 (495) 678-90-12",
    work_email: "anna.morozova@techstart.ru",
    created_at: "2024-01-10T13:20:00Z",
  },
  {
    id: 7,
    name: "Сергей Лебедев",
    position: "Руководитель отдела продаж",
    work_phone: "+7 (495) 789-01-23",
    work_email: "sergey.lebedev@innovations.ru",
    created_at: "2024-01-09T08:10:00Z",
  },
  {
    id: 8,
    name: "Татьяна Соколова",
    position: "Бухгалтер",
    work_phone: "+7 (495) 890-12-34",
    work_email: "tatyana.sokolova@progress.ru",
    created_at: "2024-01-08T15:35:00Z",
  },
  {
    id: 9,
    name: "Михаил Новиков",
    position: "Системный администратор",
    work_phone: "+7 (495) 901-23-45",
    work_email: "mikhail.novikov@startup.ru",
    created_at: "2024-01-07T12:15:00Z",
  },
  {
    id: 10,
    name: "Ольга Кузнецова",
    position: "Юрист",
    work_phone: "+7 (495) 012-34-56",
    work_email: "olga.kuznetsova@future.ru",
    created_at: "2024-01-06T09:45:00Z",
  },
];
